import $ from 'jquery'

export default {

  enable () {
    let projectName = $('#project-name').val()
    if(projectName) {
      $('.demande-info.widget input[name=projet]').val(projectName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/populate-project-info.js